import {
    call,
    select
} from 'redux-saga/effects';

// DO NOT REMOVE THIS IMPORT!!!
// This solves some sort of load-time race condition issue initially discovered
// by removing some dead code in https://github.com/urbn/MonoWeb/pull/1728.
//
// Specifically:
//     https://github.com/urbn/MonoWeb/pull/1728/commits/be7f9b7c3ce731ee4459fde19a83f23be3be7287
//
// Somehow, importing this initializes something that prevents an exception
// due to an uninitialized AccountController.  It seems the dependency graph at
// the point of the exception is:
//
//   AddressModel -> AddressController -> HeaderController -> AccountController
//
// Since Account is undergoing a Vue rewrite, we didn't dig any deeper to try
// to solve the root cause :)
//
/* eslint-disable no-unused-vars */
import helpers from '@account/js/helpers/helpers';
/* eslint-enable no-unused-vars */

import { initRouter } from '../routers/router';
import { initialSaga } from '@core/js/sagas/initialSagas';

import { getRRTileTemplate } from '@core/js/utils/rrUtils';
import { initializeDynamicYieldSaga } from '@core/js/sagas/recommendationsSagas';

export function* initializeAccountDynamicYield(state) {
    // get tileType from settings, else global rrRecs config, else fall back to TITLE_ONLY
    const tileCount = _.get(state, 'core.constants.thirdParty.default.rich_relevance.max_tile_count', 6);
    const tileType = getRRTileTemplate(state, 'core.constants.pdpOptions.recommendations_tile_type');

    const rrPlacementId = _.get(state.core.constants.thirdParty[state.core.siteId],
                          'rich_relevance.placement_ids.account');

    yield call(initializeDynamicYieldSaga, rrPlacementId, tileCount, tileType);
}

export function* accountInitialSaga() {
    yield call(initialSaga);
    const state = yield select();
    yield call(initRouter, state);
    yield call(initializeAccountDynamicYield, state);
}

export function* accountVueInitialSaga() {
    yield call(initialSaga);
    const state = yield select();
    yield call(initializeAccountDynamicYield, state);
}

export default [
    accountInitialSaga
];
